import { createSlice } from "@reduxjs/toolkit";
import { SessionSorageInstance } from "../Services/SessionStorageService";

export const GeneralSlice = createSlice({
  name: "general",
  initialState: {
    isActiveSpinner: false,
    userRol: SessionSorageInstance.getUserRole(),
    user: SessionSorageInstance.getUserDetails(),
    case_types: [],
    invoices_documents: []
  },
  reducers: {
    setIsActiveSpinner: (state, action) => {
      state.isActiveSpinner = action.payload;
    },
    setuserRol: (state, action) => {
      state.userRol = action.payload;
    },
    setCaseTypes: (state, action) => {
      state.case_types = action.payload
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});
export const { setIsActiveSpinner, setuserRol, setCaseTypes, setUser } = GeneralSlice.actions;
export default GeneralSlice.reducer;
